// extracted by mini-css-extract-plugin
export default {"selectWidth":"createInvoice_selectWidth__tuKU4","ModelContainer":"createInvoice_ModelContainer__kb6rh"};